import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from './LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading, onboardingCompleted, onboardingLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || onboardingLoading) return; // Don't navigate while loading

    if (!user) {
      navigate('/auth/login', { state: { from: location }, replace: true });
      return;
    }

    // Allow access to onboarding routes even if onboarding is not completed
    const isOnboardingRoute = location.pathname.startsWith('/onboarding');
    
    // Redirect to onboarding if not completed and not already on onboarding route
    if (!onboardingCompleted && !isOnboardingRoute) {
      navigate('/onboarding', { replace: true });
      return;
    }
  }, [user, loading, onboardingCompleted, onboardingLoading, location.pathname, navigate, location]);

  if (loading || onboardingLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <LoadingScreen />; // Show loading while navigating
  }

  // Allow access to onboarding routes even if onboarding is not completed
  const isOnboardingRoute = location.pathname.startsWith('/onboarding');
  
  // Show loading while redirecting to onboarding
  if (!onboardingCompleted && !isOnboardingRoute) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
